'use client';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { LabelLargeLink, Row } from '../../styles';
import { IconButton } from '../buttons';

type Props = {
    pages: number;
    activePage: number;
    setActivePage: (page: number) => void;
};

export const PaginationNumbers = ({ pages, activePage, setActivePage }: Props) => {
    const onNext = () => setActivePage(activePage + 1);
    const onPrevious = () => setActivePage(activePage - 1);
    const hasNextPage = activePage < pages;

    return (
        <Row style={{ justifyContent: 'center' }}>
            <IconButton
                icon={<KeyboardArrowLeft />}
                disabled={activePage === 1}
                onClick={onPrevious}
            />
            <Row gap={1.5}>
                {Array.from({ length: pages }).map((_, i) => (
                    <LabelLargeLink
                        key={i}
                        tabIndex={0}
                        isBold={i + 1 === activePage}
                        onClick={() => setActivePage(i + 1)}
                    >
                        {i + 1}
                    </LabelLargeLink>
                ))}
            </Row>
            <IconButton icon={<KeyboardArrowRight />} disabled={!hasNextPage} onClick={onNext} />
        </Row>
    );
};
